module.exports = __webpack_public_path__ + "resources/c41ede449910c2501231c08aea67b683.png";


//////////////////
// WEBPACK FOOTER
// ./resources/card-templates/backgroundsupermove6.png
// module id = 200
// module chunks = 0